import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/layout/AppShell";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Leads from "@/pages/Leads";
import LeadDetail from "@/pages/LeadDetail";
import LeadTypes from "@/pages/LeadTypes";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import CampaignCreate from "@/pages/CampaignCreate";
import ImportsWizard from "@/pages/ImportsWizard";
import ImportHistory from "@/pages/ImportHistory";
import Activity from "@/pages/Activity";
import MessageTemplates from "@/pages/MessageTemplates";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import WorkflowAdmin from "@/pages/admin/WorkflowAdmin";
import StaleSendJobs from "@/pages/admin/StaleSendJobs";
import WebsiteReviews from "@/pages/admin/WebsiteReviews";
import ChangePassword from "@/pages/ChangePassword";
import Notifications from "@/pages/Notifications";

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
                    <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
                        <Route index element={<Dashboard />} />
                        <Route path="/leads" element={<Leads />} />
                        <Route path="/leads/:id" element={<LeadDetail />} />
                        <Route path="/lead-types" element={<LeadTypes />} />
                        <Route path="/clients" element={<Clients />} />
                        <Route path="/clients/:id" element={<ClientDetail />} />
                        <Route path="/campaigns" element={<Campaigns />} />
                        <Route path="/campaigns/new" element={<CampaignCreate />} />
                        <Route path="/campaigns/:id" element={<CampaignDetail />} />
                        <Route path="/imports" element={<ImportHistory />} />
                        <Route path="/imports/new" element={<ImportsWizard />} />
                        <Route path="/activity" element={<Activity />} />
                        <Route path="/notifications" element={<Notifications />} />
                        <Route path="/templates" element={<MessageTemplates />} />
                        <Route path="/reports" element={<Reports />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="/admin/workflow" element={<WorkflowAdmin />} />
                        <Route path="/admin/stale-send-jobs" element={<StaleSendJobs />} />
                        <Route path="/admin/website-reviews" element={<WebsiteReviews />} />
                        <Route path="/admin/statuses" element={<WorkflowAdmin />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" richColors />
        </AuthProvider>
    );
}
